import { AiFillSave } from "react-icons/ai";
import { Field, Formik } from "formik"
import { Button, Card, Col, Form, Row } from "react-bootstrap"
import * as Yup from 'yup';

function AddMunicipio({agregar, initialValues, statesOpt, edit, editar}){
    const shemaValidate = Yup.object().shape({
        dsMunDel:Yup.string().required('Campo Requerido'),
        codMD:Yup.string().required('Campo Requerido'),
        state:Yup.string().required('Campo Requerido'),
    });

    return (
        <>
            <Row>
                <Col>
                    <Formik 
                        initialValues={initialValues}
                        enableReinitialize
                        validationSchema={shemaValidate}
                        onSubmit={(values, { setSubmitting, setFieldValue }) => { 
                            edit ? editar(values) : agregar(values)     
                        }}
                    >{({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue
                    }) => (
                        <Form onSubmit={handleSubmit}  className='mt-3'>
                            <Card className="shadow-1 formSection">
                                <Card.Body>
                                    <Row>
                                        <Col xs="12" md="12">
                                            <h4><span className="subtitulo">Añadir nuevo municipio</span></h4>
                                        </Col>
                                    </Row>
                                    <div className="body">
                                        <Row>
                                            <Col xs="12" md="4">
                                                <Form.Group>
                                                    <Form.Label className="font-weight-bold-600 text-secondary">Código</Form.Label>
                                                    <Field 
                                                        type="text"
                                                        className={`form-control input-form ${errors.codMD && 'error'}`}
                                                        name="codMD"
                                                    />
                                                    { errors.codMD && <div className="invalid-feedback d-block">{errors.codMD}</div> }
                                                </Form.Group>
                                            </Col>
                                            <Col xs="12" md="8">
                                                <Form.Group>
                                                    <Form.Label className="font-weight-bold-600 text-secondary">Nombre</Form.Label>
                                                    <Field 
                                                        type="text"
                                                        className={`form-control input-form ${errors.dsMunDel && 'error'}`}
                                                        name="dsMunDel"
                                                    />
                                                    { errors.dsMunDel && <div className="invalid-feedback d-block">{errors.dsMunDel}</div> }
                                                </Form.Group>
                                            </Col>
                                            <Col xs="12" md="12">
                                                <Form.Group>
                                                    <Form.Label className="font-weight-bold-600 text-secondary">Estado</Form.Label>
                                                    <Field 
                                                        as="select"
                                                        className={`form-control input-form ${errors.state && 'error'}`}
                                                        name="state"
                                                    >
                                                        <option value="">Seleccionar</option>
                                                        {
                                                            statesOpt.map((item, i)=>(
                                                                <option key={i} value={item.id}>{item.name}</option>
                                                            ))
                                                        }
                                                    </Field>
                                                    { errors.state && <div className="invalid-feedback d-block">{errors.state}</div> }
                                                </Form.Group>
                                            </Col>
                                            <Col xs="12" md="12">
                                                <Button type="submit" variant="link" className='btn-add float-right'>
                                                    <AiFillSave className="icon-save"/>
                                                </Button>{''}
                                            </Col>
                                        </Row>
                                    </div>   
                                </Card.Body>
                            </Card>
                        </Form>
                    )}</Formik>
                </Col>
            </Row>
        </>
    )

}

export default AddMunicipio